import studyStatusList from '@/assets/global_text/studyStatusList';
import studyTypeList from '@/assets/global_text/studyTypeList';
import createStudyLists from '@/assets/global_text/createStudyLists'
import respondentsWizardLists from '@/assets/global_text/respondentsWizardLists';
import contactList from '@/assets/global_text/contactList';

export default {
	// called by Vue.use(Configs)
	install (Vue, options) {
		// Configuration properties that can be accessed globally
		Object.defineProperty(Vue.prototype, '$studyStatusList', { value: studyStatusList });
		Object.defineProperty(Vue.prototype, '$studyTypeList', { value: studyTypeList });
		Object.defineProperty(Vue.prototype, '$createStudyLists', { value: createStudyLists });
		Object.defineProperty(Vue.prototype, '$respondentsWizardLists', { value: respondentsWizardLists });
		Object.defineProperty(Vue.prototype, '$contactList', { value: contactList });

	}
}
